// src/pages/fiscal/mdfe/MDFeAcaoModal.js
import React, { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import Select from '../../../components/input/Select';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import CidadeSearch from '../../geral/CidadeSearch';
import { UFS } from '../../../models/fiscal/MDFe';

const MDFeAcaoModal = ({ show, tipo, loading, onHide, onConfirm }) => {
  const [dados, setDados] = useState({});
  const [cidade, setCidade] = useState(false);
  useEffect(() => {
    if (show) setDados({});
  }, [show, tipo]);
  if (!show) return null;
  const titulo = tipo === 'cancelar' ? 'Cancelar MDF-e' : tipo === 'encerrar' ? 'Encerrar MDF-e' : 'Incluir condutor';
  return <>
    <ModalContainer show largura="550px"><ModalHeader><h5>{titulo}</h5><button type="button" className="btn-close" onClick={onHide} /></ModalHeader><ModalBody>
      {tipo === 'cancelar' && <Input label="Justificativa" rows={4} size="100%" value={dados.justificativa ?? ''} onChange={(e) => setDados({ justificativa: e.target.value })} />}
      {tipo === 'encerrar' && <div className="d-flex gap-2 flex-wrap"><Input label="Data de encerramento" type="datetime-local" size={230} value={dados.dataEncerramento ?? ''} onChange={(e) => setDados((prev) => ({ ...prev, dataEncerramento: e.target.value }))} /><Input label="Município" size={230} value={dados.municipio ?? ''} disabled btnBuscar={() => setCidade(true)} /><Select label="UF" size={100} value={dados.uf ?? ''} onChange={(e) => setDados((prev) => ({ ...prev, uf: e.target.value }))} options={[{ value: '', label: 'UF' }, ...UFS.map((uf) => ({ value: uf, label: uf }))]} /></div>}
      {tipo === 'condutor' && <div className="d-flex gap-2"><Input label="Nome" size={280} value={dados.nome ?? ''} onChange={(e) => setDados((prev) => ({ ...prev, nome: e.target.value }))} /><Input label="CPF" mask="999.999.999-99" size={170} value={dados.cpf ?? ''} onChange={(e) => setDados((prev) => ({ ...prev, cpf: e.target.value }))} /></div>}
    </ModalBody><ModalFooter><button type="button" className="btn btn-secondary" onClick={onHide}>Voltar</button><button type="button" className="btn btn-primary" disabled={loading} onClick={() => onConfirm(dados)}>Confirmar</button></ModalFooter></ModalContainer>
    <CidadeSearch show={cidade} onHide={() => setCidade(false)} onSelectCidade={(item) => {
      if (!item) {
        setCidade(false);
        return;
      }
      setDados((prev) => ({ ...prev, municipio: item.nome, codigoMunicipio: item.cMun, uf: item.uf }));
      setCidade(false);
    }} />
  </>;
};
export default MDFeAcaoModal;
